// extracted by mini-css-extract-plugin
var _1 = "_branchesTable-module__button-container";
var _2 = "_branchesTable-module__chip";
var _3 = "_branchesTable-module__danger";
export { _1 as "button-container", _2 as "chip", _3 as "danger" }
